import React, { useEffect, useState } from "react";
import "../../../../../Create_Assessment/Create_Question/CreateQuestionHw.css";
import "../../../Schedule_Q_List/ScheduleQuestionType/ImgType/imgTypeScheduleQuestion.css";
import CrossAttachmentAssessment from "../../../../../../../Assesment/pages/Create_Assessment/Attachment/CrossAttachmentAssessment";

export default function ImgTypeScheduleQuestion({ questionNumber, question }) {
  console.log(question);
  return (
    <>
      {question ? (
        <div className="d-flex align-items-center justify-content-center">
          <div className="col-11 m-0 mt-3 p-3 question_box_container">
            <div className=" d-flex">
              <div className="hw_question_no me-2">Q{questionNumber}</div>
              <div className="hw_question_box  ">{question?.title}</div>
            </div>

            <div className=" mt-2 d-flex align-items-center hw_default_dropdown_container ">
              <div className="hw_default_dropdown_card ">
                <div className="hw_default_dropdown_box_header">
                  KNOWLEDGE DOMAIN
                </div>
                <span className="hw_default_dropdown_box_size">
                  {question?.domain?.name}
                </span>
              </div>
              <div className="hw_default_dropdown_card">
                <div className="hw_default_dropdown_box_header">SKILLS</div>
                <span className=" hw_default_dropdown_box_size">
                  {question?.skill?.name}
                </span>
              </div>
              <div className="hw_default_dropdown_card">
                <div className="hw_default_dropdown_box_header">CHAPTER</div>
                <span className=" hw_default_dropdown_box_size">
                  {question?.chapter?.name}
                </span>
              </div>
              <div className="hw_default_dropdown_card">
                <div className="hw_default_dropdown_box_header">
                  TYPE OF QUESTION
                </div>
                <span className=" hw_default_dropdown_box_size">
                  {question?.type?.name}
                </span>
              </div>

              {/* <span className="ms-1 hw_default_dropdown_box_size">
              Factual Knowledge
            </span>
            <span className="hw_default_dropdown_box_size">Remembering</span>
            <span className="hw_default_dropdown_box_size">MCQ Question</span>
            <span className="hw_default_dropdown_box_size">chapter 5</span> */}
            </div>

            <div className="mt-2 hw_default_dropdown_container d-flex align-ites-center justify-content-between">
              <div className="d-flex align-items-center gap-5">
                <div className="hw_mandatory_checkbox ">
                  <input
                    checked={question?.is_mandatory}
                    readOnly
                    type="checkbox"
                  />
                  &nbsp;
                  <span>Mandatory question</span>
                </div>
                <div className="hw_mandatory_checkbox ">
                  <input
                    checked={question?.add_to === "homework"}
                    readOnly
                    type="checkbox"
                  />
                  &nbsp;
                  <span>Add for Assessment</span>
                </div>
              </div>

              <div className=" gap-3 time_duration_box d-flex justify-content-between ">
                <div className="hw_default_dropdown_card2">
                  <div className="hw_default_dropdown_box_header">MARKS</div>
                  <span className="hw_default_dropdown_box_size">
                    {question?.correct_score}
                  </span>
                </div>
                <div className="hw_default_dropdown_card2">
                  <div className="hw_default_dropdown_box_header">
                    LEVEL OF DIFFICULTY
                  </div>
                  <span className="hw_default_dropdown_box_size">
                    {question?.difficulty_level?.name}
                  </span>
                </div>
              </div>
            </div>
            {question?.attachments?.length > 0 &&
              question?.attachments?.map((attachment, index) => (
                <div className=" mt-2 hw_default_dropdown_container d-flex ">
                  <CrossAttachmentAssessment attachment={attachment} />
                </div>
              ))}

            {question?.correct_answers?.length > 0 &&
              question?.correct_answers?.map((answer, index) => (
                <div key={index} className="mt-3 ml-3 mb-3 col-12">
                  <div className="hw_mandatory_checkbox ml-1 mb-2">
                    reason for correct answer
                  </div>

                  <div
                    className="hw_correct_option_box"
                    style={{ width: "97%" }}
                  >
                    {answer?.reason_for_answer?.explanation}
                  </div>
                  <div style={{ marginLeft: "80%" }} className="mt-2">
                    <CrossAttachmentAssessment
                      attachment={answer?.reason_for_answer?.attachment}
                    />
                  </div>
                </div>
              ))}
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}
